import { useOverlayTriggerState } from '@react-stately/overlays';
import * as React from 'react';

import { useMosaicContext } from '../../hooks/use-mosaic-context';
import { getContainerDimensions } from '../../utils/container-dimensions';
import { MenuList, MenuListProps } from '../Menu/MenuList';
import { Popover } from '../Popover';

export type ContextMenuProps = React.PropsWithChildren<MenuListProps>;

export function ContextMenu({ children, ...menuListProps }: ContextMenuProps) {
  const ref = React.useRef(null);
  const [pos, setPosition] = React.useState({ top: 0, left: 0 });
  const state = useOverlayTriggerState({
    defaultOpen: false,
  });

  const { providerRef } = useMosaicContext();

  const onContextMenu = React.useCallback<React.MouseEventHandler>(
    e => {
      e.preventDefault();
      const portalContainer = providerRef?.current || document.body;
      const boundary = getContainerDimensions(portalContainer);
      const left = e.pageX - boundary.left;
      const top = e.pageY - boundary.top;
      setPosition({ top, left });
      state.open();
    },
    [state, setPosition, providerRef],
  );

  return (
    <>
      <span onContextMenu={onContextMenu}>{children}</span>
      <Popover
        isOpen={state.isOpen}
        onClose={state.close}
        left={pos.left}
        top={pos.top}
        placement="bottom left"
        appearance="minimal"
        autoFocus
        restoreFocus
        contain
        type="menu"
      >
        <MenuList {...menuListProps} onClose={state.close} />
      </Popover>
    </>
  );
}
